export const createNote = `mutation MyMutation (
  $Directionality: String,
  $Finding: String,
  $FindingInhand: String,
  $Laterality: String,
  $ServerityInhand: String,
  $Severity: String,
  $SlideID: String,
  $NoteType: String
){
  createNote(note: {
    Directionality: $Directionality,
    Finding: $Finding,
    FindingInhand: $FindingInhand,
    Laterality: $Laterality,
    ServerityInhand: $ServerityInhand,
    Severity: $Severity,
    SlideID: $SlideID,
  }, noteType: $NoteType) {
    Directionality
    Finding
    FindingInhand
    ID
    Laterality
    ServerityInhand
    SlideID
    Severity
  }
}`;

export const updateNote = `mutation MyMutation(
  $Directionality: String!,
  $Finding: String,
  $FindingInhand: String,
  $Laterality: String,
  $ServerityInhand: String,
  $Severity: String,
  $SlideID: String,
  $ID: String,
  $NoteType: String
){
  updateNote(note: {
    Directionality: $Directionality,
    Finding: $Finding,
    FindingInhand: $FindingInhand,
    Laterality: $Laterality,
    ServerityInhand: $ServerityInhand,
    Severity: $Severity,
    SlideID: $SlideID,
    ID: $ID
  }, noteType: $NoteType) {
    Directionality
    Finding
    FindingInhand
    ID
    Laterality
    ServerityInhand
    Severity
    SlideID
  }
}`;

export const removeNote = `mutation MyMutation(
  $id: string,
  $noteType: string
){
  deleteNote(id: $id, noteType: $noteType){
    Directionality
    Finding
    FindingInhand
    Laterality
    ID
    ServerityInhand
    Severity
    SlideID
  }
}`